// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {createOpenPipProgramsReport} from '../../shared/repositories';
import openPipProgramsReportActions from '../actions-list';
import sharedActions from '../../actions-list';

export const createPipProgramsReport = reportCriteria =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await createOpenPipProgramsReport(reportCriteria);

            const hasNoResult = data.length < 1;

            dispatch({
                data,
                type: openPipProgramsReportActions.UPDATE_OPEN_PIP_PROGRAMS_REPORT
            });

            dispatch({
                hasNoResult,
                type: sharedActions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } catch (error) {

            dispatch({
                hasNoResult: false,
                type: sharedActions.UPDATE_SHOW_NO_RESULTS_FOUND
            });

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/create-report.js